import 'font-awesome/less/font-awesome.less';
import './font-awesome-extension.font.js';
import './font-awesome-extension.less';

import faVariables from '!!less-vars-loader!font-awesome/less/variables.less';

function faVarToCharacter(faVarValue) {
    return faVarValue ? String.fromCharCode(parseInt(faVarValue.match(/[0-9a-f]+/i), 16)) : null;
}

var characters = {};

for (var i in faVariables) {
    characters[i.replace(/^faVar(\w)/g, function (t, c) { return c.toLowerCase(); })] = faVarToCharacter(faVariables[i]);
}

// TODO embed all icons into one font and export additional icons' characters as well
// currently additional icons will only work as CSS classes, but not on canvas or SVG (i. e. GoJS or Highcharts)
export default characters;
